import React, {
  PropTypes,
  Component
} from 'react';
import EntitiesListHorizontolContainer from './EntitiesListHorizontolContainer';
import EntitiesListHorizontolWebsiteContainer from './EntitiesListHorizontolWebsiteContainer';
import Notification from './Notification';
import Carousel from './Carousel';
import { connectToStores } from 'fluxible/addons';
import { loadMore } from '../actions/HomeLoadCreator';
import { loadUserEntity, loadHomeEntity } from '../actions/WebsiteLoadCreator';
import Search from './Search';
import UserSelection from './UserSelection';
var Rating = require('./Rating');
var cookie = require('react-cookie');


class Home extends Component {

  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  componentWillMount() {
    var response = {};
    response.id = cookie.load('sid', true);
    this.context.executeAction(loadHomeEntity, response);
  }
  componentDidMount() {
    this.userfavourite();
    $("span[class*='popularTopicEntity']").click(function(e) {
      $('#tags').val($(e.target).text().trim());
      $('#tags').focus();
    });
    navigator.geolocation.getCurrentPosition(
          (Position) => {
            cookie.save('latlong', {'lat': Position.coords.latitude, 'long': Position.coords.longitude});
          },
          (PositionError) => console.error(PositionError),
          {enableHighAccuracy: true, timeout: 20000, maximumAge: 1000}
    );
  }

  render() {
    var allentity = this.props.entities.entity;
    var Entity = [];

    function valuesToArray(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          Entity.push(obj[key]);
        }
      }
    }
    valuesToArray(allentity);
    return (
      <div>
      <div className="first-section">
        <div id="content" className="homecontent">
          <div className="homeinnercontent">
            <UserSelection/>

          </div>
        </div>
      </div>
      </div>
    );
  }
  userfavourite() {
    $('#fade').css('display', 'block');
    $('.search-container').css('display', 'none');
  }

  trending() {
    var trendingheight = $('#Trending').children().size();
    $('#Trending').css("height", +trendingheight * 190 + "px");
    var trendingheight = trendingheight * 190;
    var trendingposition = $('#Trending').css("margin-top");
    trendingposition = trendingposition.slice(0, -2);
    if (trendingposition <= -570) {
      trendingposition -= 570;
      if (trendingposition >= -trendingheight) {
        $('#Trending').animate({
          "margin-top": +trendingposition + "px"
        }, "slow");
      }
    } else {
      $('#Trending').animate({
        "margin-top": "-570px"
      }, "slow");
    }
  }
  loadAll(entities) {
    $(".whirly-loader").css('visibility', 'visible');
    this.context.executeAction(loadMore, {
      limit: entities.service.length
    });
  }
}
Home.defaultProps = {
  logindata: {}
};

Home = connectToStores(Home, ['LoginStore'], (stores, props) => {
  return {
    logindata: stores.LoginStore.get()
  };
});

module.exports = Home;



// WEBPACK FOOTER //
// ./src/components/Home.js